
export const initialUserState = {
  name: '',
  email: '',
  role: 'User',
  companyNumber: '',
  bbasPhone: '',
  uid: '',
  agentDialinCode: null,
  isDialedIn: null,
  talkingTo: null
};

export const initialCompanyState = {
  name: '',
  bbasMainPhone: '',
  intakeNotificationEmails: '',
  icon: '',
  companyNumber: ''
};

